import { messages as commonzhCN } from "./common/zh-CN.js";
import { messages as commonzhHK } from "./common/zh-HK.js";
import { messages as commonenUS } from "./common/en-US.js";
import { messages as accountzhCN } from "./account/zh-CN.js";
import { messages as accountzhHK } from "./account/zh-HK.js";
import { messages as accountenUS } from "./account/en-US.js";
import { messages as homezhCN } from "./home/zh-CN.js";
import { messages as homezhHK } from "./home/zh-HK.js";
import { messages as homeenUS } from "./home/en-US.js";
import { messages as goodszhCN } from "./goods/zh-CN.js";
import { messages as goodszhHK } from "./goods/zh-HK.js";
import { messages as goodsenUS } from "./goods/en-US.js";
import { messages as biddingzhCN } from "./bidding/zh-CN.js";
import { messages as biddingzhHK } from "./bidding/zh-HK.js";
import { messages as biddingenUS } from "./bidding/en-US.js";
import { messages as brandzhCN } from "./brand/zh-CN.js";
import { messages as brandzhHK } from "./brand/zh-HK.js";
import { messages as brandenUS } from "./brand/en-US.js";
import { messages as supplyzhCN } from "./supply/zh-CN.js";
import { messages as supplyzhHK } from "./supply/zh-HK.js";
import { messages as supplyenUS } from "./supply/en-US.js";
import { messages as orderzhCN } from "./order/zh-CN.js";
import { messages as orderzhHK } from "./order/zh-HK.js";
import { messages as orderenUS } from "./order/en-US.js";
import { messages as agentServicezhCN } from "./agentService/zh-CN.js";
import { messages as agentServicezhHK } from "./agentService/zh-HK.js";
import { messages as agentServiceenUS } from "./agentService/en-US.js";
import { messages as aizhCN } from "./ai/zh-CN.js";
import { messages as aizhHK } from "./ai/zh-HK.js";
import { messages as aienUS } from "./ai/en-US.js";
import { messages as wikizhCN } from "./wiki/zh-CN.js";
import { messages as wikizhHK } from "./wiki/zh-HK.js";
import { messages as wikienUS } from "./wiki/en-US.js";
import { messages as fileszhCN } from "./files/zh-CN.js";
import { messages as fileszhHK } from "./files/zh-HK.js";
import { messages as filesenUS } from "./files/en-US.js";
import { messages as aboutzhCN } from "./about/zh-CN.js";
import { messages as aboutzhHK } from "./about/zh-HK.js";
import { messages as aboutenUS } from "./about/en-US.js";
import { messages as pricechannelzhCN } from "./pricechannel/zh-CN.js";
import { messages as pricechannelzhHK } from "./pricechannel/zh-HK.js";
import { messages as pricechannelenUS } from "./pricechannel/en-US.js";
import { messages as managementzhCN } from "./management/zh-CN.js";
import { messages as managementzhHK } from "./management/zh-HK.js";
import { messages as managementenUS } from "./management/en-US.js";
import { messages as translationzhCN } from "./translation/zh-CN.js";
import { messages as translationzhHK } from "./translation/zh-HK.js";
import { messages as translationenUS } from "./translation/en-US.js";
// 模块只注册纯语言字段，不在词典加载时执行业务请求或重置页面状态。
export const messageModules = Object.freeze({
  common: Object.freeze({
    "zh-CN": commonzhCN,
    "zh-HK": commonzhHK,
    "en-US": commonenUS,
  }),
  account: Object.freeze({
    "zh-CN": accountzhCN,
    "zh-HK": accountzhHK,
    "en-US": accountenUS,
  }),
  home: Object.freeze({
    "zh-CN": homezhCN,
    "zh-HK": homezhHK,
    "en-US": homeenUS,
  }),
  goods: Object.freeze({
    "zh-CN": goodszhCN,
    "zh-HK": goodszhHK,
    "en-US": goodsenUS,
  }),
  bidding: Object.freeze({
    "zh-CN": biddingzhCN,
    "zh-HK": biddingzhHK,
    "en-US": biddingenUS,
  }),
  brand: Object.freeze({
    "zh-CN": brandzhCN,
    "zh-HK": brandzhHK,
    "en-US": brandenUS,
  }),
  supply: Object.freeze({
    "zh-CN": supplyzhCN,
    "zh-HK": supplyzhHK,
    "en-US": supplyenUS,
  }),
  order: Object.freeze({
    "zh-CN": orderzhCN,
    "zh-HK": orderzhHK,
    "en-US": orderenUS,
  }),
  agentService: Object.freeze({
    "zh-CN": agentServicezhCN,
    "zh-HK": agentServicezhHK,
    "en-US": agentServiceenUS,
  }),
  ai: Object.freeze({ "zh-CN": aizhCN, "zh-HK": aizhHK, "en-US": aienUS }),
  wiki: Object.freeze({
    "zh-CN": wikizhCN,
    "zh-HK": wikizhHK,
    "en-US": wikienUS,
  }),
  files: Object.freeze({
    "zh-CN": fileszhCN,
    "zh-HK": fileszhHK,
    "en-US": filesenUS,
  }),
  about: Object.freeze({
    "zh-CN": aboutzhCN,
    "zh-HK": aboutzhHK,
    "en-US": aboutenUS,
  }),
  pricechannel: Object.freeze({
    "zh-CN": pricechannelzhCN,
    "zh-HK": pricechannelzhHK,
    "en-US": pricechannelenUS,
  }),
  management: Object.freeze({
    "zh-CN": managementzhCN,
    "zh-HK": managementzhHK,
    "en-US": managementenUS,
  }),
  translation: Object.freeze({
    "zh-CN": translationzhCN,
    "zh-HK": translationzhHK,
    "en-US": translationenUS,
  }),
});
